import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { Flex } from 'foundations-components/components/Flex';
import { Progress } from 'foundations-components/transitional/components/Progress';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DocumentProgressNameCell = ({
  searchResult
}) => /*#__PURE__*/_jsxs(Flex, {
  alignItems: "center",
  justifyContent: "space-between",
  children: [/*#__PURE__*/_jsx(TruncateString, {
    tooltip: false,
    maxWidth: 160,
    children: searchResult.name
  }), /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    maxInlineSize: "100px",
    children: /*#__PURE__*/_jsx(Progress, {
      marginInlineStart: "500",
      marginBlockEnd: "0",
      use: "success",
      value: searchResult.getIn(['metadata', 'progress'])
    })
  })]
});
export default DocumentProgressNameCell;